/**
* Animates cards opacity for ease-in rendering.
*
* @param delay - Rendering delay between one card and another
*/
class ConfigCardsAnimation {
}
class CardAnimation {
    constructor() {
        this.initCardsAnimation = (configCardsAnimation) => {
            if (!configCardsAnimation.cardsToAnimateNodeList) {
                configCardsAnimation.cardsToAnimateNodeList = document.querySelectorAll("[data-animate-opacity]");
            }
            if (configCardsAnimation.cardsToAnimateNodeList && configCardsAnimation.cardsToAnimateNodeList.length > 0) {
                configCardsAnimation.cardsToAnimateNodeList.forEach((card, index) => {
                    this.iteratorCard(card, configCardsAnimation, index + 1); //this plus one is necessary in order to avoid 0 being passed, resulting in a card not being printed
                });
            }
        };
    }
    iteratorCard(card, configCardsAnimation, index) {
        if (card && configCardsAnimation && index) {
            if (card.hasAttribute("data-animate-opacity")) {
                imagesLoaded(card, () => {
                    setTimeout(() => {
                        card.classList.add("active");
                    }, configCardsAnimation.delay * index);
                });
            }
        }
    }
}
